var AVQ_DESKTOP_MIN = 992;
jQuery(document).ready(function($){
	// Prevent scrolling when mobile menu is open
	$('.navbar-toggler').click( function () {
		$('body').toggleClass('prevent-scroll');
	})
	if ( $(window).width() < AVQ_DESKTOP_MIN ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			$('.dropdown-menu').addClass('show');
		});

  	$('.nav-link').click(function(){
		$("#navbarNavDropdown").removeClass("show");
	  $("button.navbar-toggler").addClass("collapsed");
	  $("button.navbar-toggler").attr("aria-expanded","false");
	});

  } else {

  	//open menu on hover for desktop
		$('#menuToggle, #navbarNavDropdown').hover(function(){
			$('.navbar-wrapper').addClass('active');
		}, function(){
			$('.navbar-wrapper').removeClass('active');
		});

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})
  }
  document.addEventListener("DOMContentLoaded", function () {
	  const mybutton = document.getElementById("btt");

	  if (mybutton) {
	    // Show/hide on scroll
	    window.addEventListener("scroll", function () {
	      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	        mybutton.style.display = "block";
	      } else {
	        mybutton.style.display = "none";
	      }
	    });

	    // Scroll to top on click
	    mybutton.addEventListener("click", function () {
	      document.body.scrollTop = 0; // For Safari
	      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	    });
	  }
	});


  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault(); // <=====================
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);

	})

	$(document).on('facetwp-loaded', function() {
	    $('.facetwp-facet-search .facetwp-icon').hide();
	    $('.facetwp-facet-search .facetwp-input-wrap').each(function() {
	        if ($(this).find('.facetwp-search-submit').length < 1) {
	            $(this).find('.facetwp-search').after('<button class="facetwp-search-submit" onclick="FWP.refresh()">Search</button>');
	        }
	    });
	});

	// Lightbox initialization
	if (typeof GLightbox !== 'undefined') {
		GLightbox({ selector: '.video-lightbox' });
	}

	// Slick slider initialization
	$('.video-slider').each(function () {
		const $slider = $(this);
		const slideCount = $slider.find('.video-slide').length;

		$slider.slick({
			dots: false,
			arrows: slideCount > 1, // disable arrows if only one slide
			prevArrow: $('.slick-prev'),
			nextArrow: $('.slick-next'),
			adaptiveHeight: true
		});
	});


    // Play button overlay handler
    $('.play-button-overlay').on('click', function () {
	    const wrapper = $(this).closest('.video-slide');
	    const video = wrapper.find('video').get(0);

	    if (video) {
	        video.setAttribute('controls', true);
	        video.play();
	    }

	    $(this).fadeOut();
	});


	// Pause videos and show overlays when slide changes
	$('.video-slider').on('beforeChange', function () {
	    $('.video-player').each(function () {
	        this.pause();
	        this.removeAttribute('controls');
	        this.currentTime = 0;
	    });
	    $('.play-button-overlay').fadeIn();
	});

	// Click poster to play and hide overlay
	$('.video-slide video').on('play', function () {
		$(this).siblings('.play-button-overlay').fadeOut();
	});

	document.querySelectorAll('.bargraph').forEach(graph => {
    graph.querySelectorAll('.bar-container').forEach(container => {
        const widthPercent = container.getAttribute('data-width');
        const displayValue = container.getAttribute('data-value');
        const bar = container.querySelector('.bargraph-bar');

        const percentageLabel = document.createElement('div');
        percentageLabel.classList.add('bargraph-percentage');
        percentageLabel.textContent = '0%';
        container.appendChild(percentageLabel);

        if(window.innerWidth < AVQ_DESKTOP_MIN){
        
            gsap.to(bar, {
                scrollTrigger: {
                    trigger: graph,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                },
                height: `${widthPercent}%`,
                duration: 1.5,
                ease: "power2.out",
                onUpdate: () => {
                    const barHeight = bar.offsetHeight;
                    percentageLabel.style.bottom = `${barHeight + 5}px`;
                }
            });

        }
        else{

            gsap.to(bar, {
                scrollTrigger: {
                    trigger: graph,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                },
                width: `${widthPercent}%`,
                duration: 1.5,
                ease: "power2.out",
                onUpdate: () => {
                    const barWidth = bar.offsetWidth;
                    percentageLabel.style.left = `${barWidth + 15}px`;
                }
            });

        }

        gsap.to({val: 0}, {
            val: displayValue,
            duration: 1.5,
            ease: "power2.out",
            scrollTrigger: {
                trigger: graph,
                start: 'top 80%',
                toggleActions: 'play none none none'
            },
            onUpdate: function() {
                percentageLabel.textContent = `${Math.round(this.targets()[0].val)}%`;
            }
        });
    });
});

var countTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: document.querySelectorAll('.briefwrap'),
      start: 'top bottom',
      once: true
    }
  });
gsap.utils.toArray('[data-counter]').forEach(function (el) {
var target = {
    val: 1
};
countTimeline.to(target, {
    val: el.getAttribute('data-counter'),
    duration: el.getAttribute('data-speed'),
    onUpdate: function () {
    el.innerText = target.val.toFixed(0);
    }
}, "+=-10");
});


document.querySelectorAll('.vertical-bar-graph').forEach(graph => {
    graph.querySelectorAll('.vertical-bar-graph__item').forEach(item => {
        const heightPercent = parseFloat(item.getAttribute('data-height')) || 0;
        const displayValue = parseFloat(item.getAttribute('data-display')) || 0;
        const bar = item.querySelector('.vertical-bar-graph__bar');
        const valueLabel = item.querySelector('.vertical-bar-graph__value');
        const isPositive = item.classList.contains('is-positive');

        gsap.to(bar, {
            scrollTrigger: {
                trigger: graph,
                start: 'top 80%',
                toggleActions: 'play none none none'
            },
            height: `${heightPercent}%`,
            duration: 1.5,
            ease: 'power2.out',
            onUpdate: () => {
                const barHeight = bar.offsetHeight;

                if (isPositive) {
                    valueLabel.style.bottom = `${parseInt(getComputedStyle(graph).getPropertyValue('--negative-zone')) + barHeight + 8}px`;
                } else {
                    valueLabel.style.top = `${parseInt(getComputedStyle(graph).getPropertyValue('--positive-zone')) + barHeight + 8}px`;
                }
            }
        });

        gsap.to({ val: 0 }, {
            val: displayValue,
            duration: 1.5,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: graph,
                start: 'top 80%',
                toggleActions: 'play none none none'
            },
            onUpdate: function () {
                const current = Math.round(this.targets()[0].val);

                if (current > 0) {
                    valueLabel.textContent = `+${current}%`;
                } else if (current < 0) {
                    valueLabel.textContent = `${current}%`;
                } else {
                    valueLabel.textContent = '0%';
                }
            }
        });
    });
});

document.querySelectorAll('.block-toggle-dot').forEach(block => {
    const toggles = block.querySelectorAll('.toggle-dot__toggle');
    const panels = block.querySelectorAll('.toggle-dot__party-panel');

    if (!toggles.length || !panels.length) {
        return;
    }

    function animatePanel(panel) {
        if (!panel) {
            return;
        }

        const dots = panel.querySelectorAll('.toggle-dot__dot');
        const labels = panel.querySelectorAll('.toggle-dot__plot-label');
        const values = panel.querySelectorAll('.toggle-dot__plot-value');

        gsap.killTweensOf(dots);
        gsap.killTweensOf(labels);
        gsap.killTweensOf(values);

        gsap.set(dots, {
            opacity: 0,
            y: -28,
            scale: 0.9
        });

        gsap.set(labels, {
            opacity: 0,
            y: 12
        });

        gsap.set(values, {
            opacity: 0,
            y: 12
        });

        const tl = gsap.timeline();

        tl.to(dots, {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 0.5,
            ease: 'back.out(1.4)',
            stagger: {
                each: 0.015,
                from: 'start'
            }
        });

        tl.to(labels, {
            opacity: 1,
            y: 0,
            duration: 0.35,
            ease: 'power2.out',
            stagger: 0.08
        }, '-=0.18');

        tl.to(values, {
            opacity: 1,
            y: 0,
            duration: 0.35,
            ease: 'power2.out',
            stagger: 0.08
        }, '-=0.2');
    }

    function setActiveParty(index) {
        toggles.forEach((toggle, i) => {
            const isActive = i === index;
            toggle.classList.toggle('is-active', isActive);
            toggle.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel, i) => {
            panel.classList.toggle('is-active', i === index);
        });

        const activeToggle = toggles[index];
        const headerColor = activeToggle.getAttribute('data-header-color');
        const backgroundColor = activeToggle.getAttribute('data-background-color');

        block.style.setProperty('--toggle-dot-header-color', headerColor);
        block.style.setProperty('--toggle-dot-background-color', backgroundColor);
    }

    toggles.forEach((toggle, index) => {
        toggle.addEventListener('click', () => {
            setActiveParty(index);
        });
    });

    setActiveParty(0);

    ScrollTrigger.create({
        trigger: block,
        start: 'top 75%',
        once: true,
        onEnter: () => {
            animatePanel(panels[0]);
        }
    });
});

document.querySelectorAll('.grouped-bar-graph').forEach(graph => {
    const groups = graph.querySelectorAll('.grouped-bar-graph__group');

    if (!groups.length) {
        return;
    }

    ScrollTrigger.create({
        trigger: graph,
        start: 'top 80%',
        once: true,
        onEnter: () => {
            groups.forEach((group, groupIndex) => {
                const items = group.querySelectorAll('.grouped-bar-graph__item');

                items.forEach((item, itemIndex) => {
                    const bar = item.querySelector('.grouped-bar-graph__bar');
                    const value = item.querySelector('.grouped-bar-graph__value');
                    const label = item.querySelector('.grouped-bar-graph__item-label');
                    const heightPercent = parseFloat(item.getAttribute('data-height')) || 0;

                    gsap.set(bar, { height: 0 });
                    gsap.set(value, { opacity: 0, y: 8 });
                    gsap.set(label, { opacity: 0, y: 8 });

                    gsap.to(bar, {
                        height: `${heightPercent}%`,
                        duration: 0.8,
                        ease: 'power2.out',
                        delay: groupIndex * 0.15 + itemIndex * 0.08
                    });

                    gsap.to(value, {
                        opacity: 1,
                        y: 0,
                        duration: 0.35,
                        ease: 'power2.out',
                        delay: groupIndex * 0.15 + itemIndex * 0.08 + 0.35
                    });

                    gsap.to(label, {
                        opacity: 1,
                        y: 0,
                        duration: 0.35,
                        ease: 'power2.out',
                        delay: groupIndex * 0.15 + itemIndex * 0.08 + 0.45
                    });
                });
            });
        }
    });
});
});